<template>
  <!-- A catalog item's real logo (its own colours, never tinted). With none — or
       if the image fails to load — a neutral icon, not a brand-green one. -->
  <img v-if="src && !failed" :src="src" :width="size" :height="size" alt="" aria-hidden="true"
       class="kvm-logo flex-grow-0" @error="failed = true">
  <v-icon v-else :size="size" class="kvm-logo kvm-logo--icon flex-grow-0" aria-hidden="true">{{ icon }}</v-icon>
</template>

<script>
import { logoUrl, fallbackIcon } from '@/helpers/catalogLogos'

export default {
  name: 'KvmLogo',
  props: {
    // Any catalog-ish object: { logo_url, icon, slug, template, os, app, name }.
    item: { type: Object, default: null },
    size: { type: [Number, String], default: 32 },
    // Icon when there's no logo (e.g. 'mdi-docker' for apps, 'mdi-server' for servers).
    defaultIcon: { type: String, default: 'mdi-application' },
  },
  data: () => ({ failed: false }),
  computed: {
    src () { return logoUrl(this.item) },
    icon () { return fallbackIcon(this.item, this.defaultIcon) },
  },
  watch: {
    src () { this.failed = false },
  },
}
</script>

<style scoped lang="scss">
@import './kvm-ui';

.kvm-logo { object-fit: contain; }
// .v-icon too: outranks Vuetify's theme icon colour.
.kvm-logo--icon.v-icon { @include kvm-secondary-text; }
</style>
